import { Users, FileText, BarChart3, Newspaper, CheckCircle } from 'lucide-react';

const OverviewTab = ({ stats }) => {
  if (!stats) return null;
  const cards = [
    { label: 'Registered Users', value: stats.users, icon: Users, color: '#0066CC' },
    { label: 'Contact Submissions', value: stats.contact_submissions, icon: FileText, color: '#14b8a6' },
    { label: 'Demo Requests', value: stats.demo_requests, icon: BarChart3, color: '#8b5cf6' },
    { label: 'Newsletter Subscribers', value: stats.newsletter_subscribers, icon: Newspaper, color: '#f59e0b' },
    { label: 'Content Items', value: stats.content_items, icon: FileText, color: '#10b981' },
    { label: 'Qualified Leads', value: stats.qualified_leads, icon: CheckCircle, color: '#ef4444' },
  ];

  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="admin-overview">
      {cards.map((card) => {
        const Icon = card.icon;
        return (
          <div key={card.label} className="bg-white rounded-2xl border border-slate-200 p-5">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${card.color}12` }}>
                <Icon className="w-4 h-4" style={{ color: card.color }} strokeWidth={1.5} />
              </div>
              <span className="text-xs font-bold text-slate-400 uppercase tracking-wide">{card.label}</span>
            </div>
            <div className="font-heading text-3xl font-bold text-taxera-charcoal">{card.value}</div>
          </div>
        );
      })}
    </div>
  );
};

export default OverviewTab;
